import {
    Menu,
    Button,
    Icon,
  } from "@chakra-ui/react"
  import { FaChevronDown, FaGlobe } from "react-icons/fa6"
  
  export type LanguageOption = {
    label: string
    code: string
  }
  
  interface LanguageMenuProps {
    loading?: boolean
    disabled?: boolean
    onSelect: (langCode: string) => void
    options?: LanguageOption[]
  }
  
  export function LanguageMenu({
    loading = false,
    disabled = false,
    onSelect,
    options = [
      { label: "English", code: "en" },
      { label: "한국어", code: "ko" },
      { label: "日本語", code: "ja" },
      { label: "中文", code: "zh" },
      { label: "Deutsch", code: "de" },
      { label: "Français", code: "fr" },
    ]
  }: LanguageMenuProps) {
    return (
      <Menu.Root>
        <Menu.Trigger asChild>
          <Button
            variant="ghost"
            size="sm"
            colorScheme="blue"
            loading={loading}
            disabled={disabled}
          >
            <Icon as={FaGlobe} fontSize="16px" mr={1} />
            번역
            <Icon as={FaChevronDown} fontSize="16px" mr={1} />
          </Button>
        </Menu.Trigger>
  
        <Menu.Positioner>
          <Menu.Content>
            {options.map((lang) => (
              <Menu.Item
                key={lang.code}
                value={lang.code} 
                onSelect={() => onSelect(lang.code)}
              >
                {lang.label}
              </Menu.Item>
            ))}
          </Menu.Content>
        </Menu.Positioner>
      </Menu.Root>
    )
  }
  